export const endpoints = {
    ORGANIZATION_ADMIN: "/organization/admin/view",
    ORGANIZATION_ADMIN_CREATE: "/organization/admin/create",
    ORGANIZATION_ADMIN_UPDATE: "/organization/admin/update",
    ORGANIZATION_ADMIN_DELETE: "/organization/admin/delete",

    SUBSIDIARIES_IDS: "/organization/subsidiary/view"
}